const messages = {
  title: "À propos de BS Plus",
  description: "About page description",
};

export default {
  messages,
};
